module.exports = "https://cdn2-fs.clearscore.com/flux/images/a0306c8bde6e4f1910dac4062bebf2a9.jpg";